<div class="delete-confirmation-dialog">
  <h2 mat-dialog-title>
    <mat-icon class="warning-icon">warning</mat-icon>
    Delete Recurring Activity
  </h2>

  <mat-dialog-content>
    <!-- Loading state -->
    <div *ngIf="data.isLoading" class="loading-content">
      <img src="assets/hm-loading-new.gif" alt="Loading" class="loading-gif">
      <p class="loading-text">Loading data from eCase server...</p>
    </div>

    <!-- Loaded content -->
    <div *ngIf="!data.isLoading" class="warning-box">
      <p class="warning-text">
        You are about to <strong>permanently delete</strong> the following recurring activity:
      </p>

      <div class="activity-details">
        <div class="detail-row">
          <span class="label">Activity:</span>
          <span class="value">{{ data.description }}</span>
        </div>
        <div class="detail-row">
          <span class="label">Resident:</span>
          <span class="value">{{ data.residentName }}</span>
        </div>
        <div class="detail-row">
          <span class="label">Instances:</span>
          <span class="value instances">{{ data.instanceCount }}</span>
        </div>
        <div class="detail-row">
          <span class="label">Date Range:</span>
          <span class="value">{{ data.dateRange }}</span>
        </div>
      </div>

      <p class="warning-text">
        <strong>Warning:</strong> This action cannot be undone. All {{ data.instanceCount }} instances of this activity will be removed from the worklog.
      </p>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions>
    <button mat-button (click)="onCancel()" class="cancel-button">
      Cancel
    </button>
    <button mat-raised-button (click)="onConfirm()" class="delete-button" [disabled]="data.isLoading">
      Delete All {{ data.instanceCount }} Instances
    </button>
  </mat-dialog-actions>
</div>
